export default {
  ru: 'https://gorillaenergy.ru',
  am: 'https://am.gorillaenergy.com',
  ca: 'https://ca.gorillaenergy.com',
  cy: 'https://cy.gorillaenergy.com',
  fr: 'https://fr.gorillaenergy.com',
  ge: 'https://ge.gorillaenergy.com',
  kz: 'https://kz.gorillaenergy.com',
  kg: 'https://kg.gorillaenergy.com',
  md: 'https://md.gorillaenergy.com',
  kr: 'https://ko.gorillaenergy.com',
  rs: 'https://sr.gorillaenergy.com',
  tr: 'https://gorillaenergy.com.tr',
  tj: 'https://tj.gorillaenergy.com',
  ar: 'https://ae.gorillaenergy.com',
  gb: 'https://uk.gorillaenergy.com',
  uz: 'https://uz.gorillaenergy.com',
  usa: 'https://gorillaenergy.us'
}
